import React, { PureComponent } from 'react';
import DialogWrapper from '../../../common/components/DialogWrapper/DialogWrapper';
import { TextField, MenuItem } from '@mui/material';
import PermissionsCheck from '../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../common/constants/PermissionsEnum';

class AddUserDialog extends PureComponent {
  render() {
    return (
      <DialogWrapper
        onClickCancel={this.props.onClickCancel}
        onClickMainAction={this.props.onClickMainAction}
        open={this.props.open}
        title="Assign users"
        disableMainAction={this.props.disableMainAction || this.props.assignableUsers.length === 0}
        data-qa="qa-add-user-dialog"
      >
        {this.props.assignableUsers.length > 0 ? (
          <div>
            <PermissionsCheck permission={PermissionsEnum.VIEW_ALL_USERS_FOR_GROUP_ASSIGNMENT}>
              <TextField
                variant="standard"
                select={true}
                label="Select a user"
                value={this.props.selectedUserId}
                onChange={(e) => this.props.handleSelectedUser(e.target.value)}
                style={{ width: '100%' }}
                data-qa="qa-assign-user-field"
              >
                {this.props.assignableUsers.map((user) => (
                  <MenuItem key={user.UserEntityId} value={user.UserEntityId}>
                    {`${user.Username}, ${user.Email}`}
                  </MenuItem>
                ))}
              </TextField>
            </PermissionsCheck>
            <PermissionsCheck
              permission={PermissionsEnum.VIEW_ALL_USERS_FOR_GROUP_ASSIGNMENT}
              hasPermission={false}
            >
              <TextField
                variant="standard"
                data-qa="qa-emailInput"
                label="Email"
                placeholder="Enter an email address in the form of address@domain.com."
                fullWidth={true}
                error={this.props.emailErrorMessage !== ''}
                helperText={this.props.emailErrorMessage}
                value={this.props.selectedUserEmail}
                onChange={(e) => this.props.handleSelectedUserEmail(e.target.value)}
                margin="normal"
              />
            </PermissionsCheck>
          </div>
        ) : (
          <div>No available users for this group.</div>
        )}
      </DialogWrapper>
    );
  }
}

export default AddUserDialog;
